export default __webpack_public_path__ + "static/media/3099.65b3dd29.jpg";